import { render, staticRenderFns } from "./InvoiceLab.vue?vue&type=template&id=e44d3d98&"
import script from "./InvoiceLab.vue?vue&type=script&lang=js&"
export * from "./InvoiceLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports